module.exports = __webpack_public_path__ + "static/media/refresh-white-24dp.18646fe4.svg";